// extracted by mini-css-extract-plugin
module.exports = {"typeSection":"GraphicsTypeSection_typeSection__1Y5eE","label":"GraphicsTypeSection_label__iuumn"};